import styled from 'styled-components';
const SearchGroupStyled = styled.div`
  .search-wrapper {
    display: flex;
  }

  margin: 24px 32px;

  .left {
    flex-grow: 1;
    display: flex;
    align-items: center;
  }

  .button-group {
    height: 100%;
    margin-left: 64px;
    display: flex;
    /* flex-direction: column; */
    justify-content: space-between;
    align-items: center;
    .reset {
      margin-right: 24px;
    }
    .search {
      margin-right: 0;
    }
  }
  .first-line {
    width: 100%;
    display: flex;
    height: 100%;
    align-items: center;
    gap: 48px;
    flex: 1;
    > div {
      flex: 1;
      /* width: 25%; */
      /* margin-right: 48px; */
    }
  }

  .single-select {
    /* width: 400px; */
    /* height: 56px; */
  }

  .MuiTextField-root {
    /* width: 400px; */
    /* height: 56px; */
  }
`;
export default SearchGroupStyled;
